import { CloseIcon } from "../../../assets/icons";
import styles from "./HelpModal.module.scss";

interface Props {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	description: string;
}

export const HelpModal = ({ isOpen, onClose, title, description }: Props) => {
	if (!isOpen) return null;

	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles.wrapper} onClick={e => e.stopPropagation()}>
				<div className={styles.card}>
					<span className={styles.chip}>Quick Guide</span>
					<h2 className={styles.title}>{title}</h2>
					<p className={styles.description}>{description}</p>
				</div>
				<button className={styles.closeBtn} onClick={onClose} type="button" aria-label="Close">
					<CloseIcon />
				</button>
			</div>
		</div>
	);
};
